import { render } from "./P036.vue?vue&type=template&id=3d7a0f08&scoped=true"
import script from "./P036.vue?vue&type=script&lang=js"
export * from "./P036.vue?vue&type=script&lang=js"

import "./P036.vue?vue&type=style&index=0&id=3d7a0f08&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7a0f08"]])

export default __exports__